module.exports = __webpack_public_path__ + "static/media/cellfinate_works_before_after.6063cc58.jpg";